"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Support commonjs
module.exports = exports = chain;
/**
 * Chain a stack of rill middleware into one composed function.
 *
 * @param stack An array of middleware arguments to convert to a function.
 */
function chain(stack) {
    if (!Array.isArray(stack)) {
        throw new TypeError("Rill: Middleware stack must be an array.");
    }
    var fns = normalize(stack, []);
    return function (ctx, next) {
        var index = -1; // Last called middleware.
        return dispatch(0);
        function dispatch(i) {
            if (i <= index) {
                return Promise.reject(new Error("Rill: next() called multiple times."));
            }
            var fn = fns[i] || next;
            index = i;
            try {
                return Promise.resolve(fn && fn(ctx, function () { return dispatch(i + 1); }));
            }
            catch (err) {
                return Promise.reject(err);
            }
        }
    };
}
exports.default = chain;
/**
 * Utility to (recursively) normalize a middleware stack and check for validity.
 * @param stack An array of middleware arguments to convert to a function.
 * @param fns The current list of normalized middleware functions.
 * @internal
 */
function normalize(stack, fns) {
    for (var _i = 0, stack_1 = stack; _i < stack_1.length; _i++) {
        var fn = stack_1[_i];
        if (!fn) {
            continue;
        }
        if (typeof fn === "function") {
            fns.push(fn);
        }
        else if (Array.isArray(fn)) {
            normalize(fn, fns);
        }
        else if (Array.isArray(fn.stack)) {
            normalize(fn.stack, fns);
        }
        else {
            throw new TypeError("Rill: Invalid middleware provided. Got a [" +
                fn.constructor.name +
                "].");
        }
    }
    return fns;
}
//# sourceMappingURL=index.js.map